import CreateHttpClient from './createTimetablesWebApiHttpClient';
import { AxiosInstance, AxiosResponse } from 'axios';
import moment from 'moment';
import { MOMENT_DATE_FORMAT } from '../constants/date_format';

class BuildingApi {
    httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async GetBuildingSchedule(buildingId: number, date: Date) {
        const formattedDate = moment(date).format(MOMENT_DATE_FORMAT);
        const { data } = await this.httpClient.get(`/buildings/schedule?buildingId=${buildingId}&date=${formattedDate}`);
        return data;
    }

    async GetAllBuildings(campusId?: number) {
        let url = `/buildings`;

        if (campusId) url += `?campusId=${campusId}`;

        const { data } = await this.httpClient.get(url);
        return data;
    }

    async GetWeeklyReport(buildingId: number, date: string, includeSet: boolean, isNight: boolean): Promise<FileResponse> {
        const file_data = await this.httpClient
            .get(`/buildings/week-schedule-export?buildingId=${buildingId}&date=${date}&includeSet=${includeSet}&isNight=${isNight}`, { responseType: 'arraybuffer' })
            .then(function (response: AxiosResponse) {
                // Example string: Content-Disposition: attachment; filename="EURO rates.csv"; filename*=utf-8''%e2%82%ac%20rates.csv
                // The filename= tag can be case-insensitive, so use regexp on the split

                let contentDisposition = response.headers['content-disposition'];
                let fileName = `weekly_${isNight ? `night` : `day`}_report_${date}.xlsx`;

                if (contentDisposition) {
                    fileName = response.headers['content-disposition'].split(new RegExp('filename=', 'ig'))[1].split(';')[0].replaceAll('"', '').trim();
                }

                let fileType = response.headers['content-type'];
                let fileBlob = new Blob([response.data], { type: fileType });

                return {
                    fileName: fileName,
                    fileBlob: fileBlob,
                    fileType: fileType,
                } as FileResponse;
            });
        return file_data;
    }

    async GetConflicts(buildingId: number, startDate: Date, endDate: Date) {
        const formattedStartDate = moment(startDate).format(MOMENT_DATE_FORMAT);
        const formattedEndDate = moment(endDate).format(MOMENT_DATE_FORMAT);

        const endpoint = `/buildings/conflicts?buildingId=${buildingId}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
        const { data } = await this.httpClient.get(endpoint);
        return data;
    }
}

type FileResponse = {
    fileName: string;
    fileBlob: Blob;
    fileType: string;
};

export default BuildingApi;
